<template>
  <div class="home">
    <innerHeader v-if="!isMobile" :ind="1"></innerHeader>
    <AppHeader v-if="isMobile" />
    <ResponsiveContainer>
      <div class="main">
        <!--cloumnId控制contentList  Tab的active -->
        <contentList
          @tabChagnge="tabChagnge"
          :tabList="tabList"
          :leftTab="2"
          :cloumnId="cloumnId"
          v-if="!isMobile"
          class="bg"
        >
          <div slot="main_content">
            <div class="content_top" v-if="Object.keys(detail).length">
              <div class="article_con">
                <div class="contact contact1">
                  <div
                    class="contact_item"
                    v-if="detail.contact1 && detail.contact1 != ''"
                  >
                    <p v-html="detail.contact1"> </p>
                  </div>
                </div>
                <div class="contact contact2">
                  <div
                    class="contact_item"
                    v-if="detail.contact2 && detail.contact2 != ''"
                  >
                    <p v-html="detail.contact2"> </p>
                  </div>

                  <div
                    class="contact_item"
                    v-if="detail.contact3 && detail.contact3 != ''"
                  >
                    <p v-html="detail.contact3"> </p>
                  </div>
                </div>
                <div class="contact contact2">
                  <div
                    class="contact_item"
                    v-if="detail.contact4 && detail.contact4 != ''"
                  >
                    <p v-html="detail.contact4"> </p>
                  </div>

                  <div
                    class="contact_item"
                    v-if="detail.contact5 && detail.contact5 != ''"
                  >
                    <p v-html="detail.contact5"> </p>
                  </div>
                </div>
                <div class="contact contact2">
                  <div
                    class="contact_item"
                    v-if="detail.contact6 && detail.contact6 != ''"
                  >
                    <p v-html="detail.contact6"> </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="content_top" v-else>
              <el-empty :description="$t('noData')"></el-empty>
            </div>
          </div>
        </contentList>
        <AppcontentList
          @tabChagnge="tabChagnge"
          :tabList="tabList"
          :leftTab="2"
          :cloumnId="cloumnId"
          :contentBg="contentBg2"
          v-if="isMobile"
          class="appbg"
        >
          <div slot="main_content">
            <div class="app_content_top">
              <div class="article_con">
                <div
                  class="contact_item"
                  v-if="detail.contact1 && detail.contac1 != ''"
                >
                  <p class="app_detail_con" v-html="detail.contact1"> </p>
                </div>

                <div
                  class="contact_item"
                  v-if="detail.contact2 && detail.contac2 != ''"
                >
                  <p class="app_detail_con" v-html="detail.contact2"> </p>
                </div>

                <div
                  class="contact_item"
                  v-if="detail.contact3 && detail.contac3 != ''"
                >
                  <p class="app_detail_con" v-html="detail.contact3"> </p>
                </div>

                <div
                  class="contact_item"
                  v-if="detail.contact4 && detail.contac4 != ''"
                >
                  <p class="app_detail_con" v-html="detail.contact4"> </p>
                </div>

                <div
                  class="contact_item"
                  v-if="detail.contact5 && detail.contac5 != ''"
                >
                  <p class="app_detail_con" v-html="detail.contact5"> </p>
                </div>

                <div
                  class="contact_item"
                  v-if="detail.contact6 && detail.contac6 != ''"
                >
                  <p class="app_detail_con" v-html="detail.contact6"> </p>
                </div>
              </div>
            </div>
          </div></AppcontentList
        >
        <!-- <paginations
          :current-page.sync="page.current"
          @current-change="currentChange"
          :page-size="page.size"
          :total="page.total"
        ></paginations> -->
      </div>
    </ResponsiveContainer>
    <Footer v-if="!isMobile" />
    <innerAppFooter v-else />
  </div>
</template>

<script>
import innerHeader from '@/components/innerHeader.vue';
import AppHeader from '@/components/AppHeader';
import Footer from '@/components/Footer.vue';
import innerAppFooter from '@/components/innerAppFooter';
import ResponsiveContainer from '@/components/ResponsiveContainer';
import contentList from '@/components/contentList';
import AppcontentList from '@/components/AppcontentList';
import paginations from '@/components/Pagination.vue';
import responsiveMixin from '@/mixins/responsiveMixin';
import { presidumTab } from '@/const';
import { getPageObj } from '@/assets/api';
export default {
  name: 'AboutUs',
  mixins: [responsiveMixin],
  components: {
    innerHeader,
    AppHeader,
    innerAppFooter,
    Footer,
    ResponsiveContainer,
    contentList,
    AppcontentList,
    paginations,
  },
  data() {
    return {
      contentBg: require('../../assets/img/homeimgs/presi_bg.png'),
      contentBg2: require('../../assets/img/appImg/presi_bg.png'),
      currentIndex: 0,
      tabList: presidumTab,

      cloumnId: null, //栏目id
      detail: {
        title: '似是闯入梦幻地心世界',
        content:
          '<p cms-style="font-L" style="margin-top: 15px; margin-bottom: 15px; font-size: 16px; line-height: 2em; color: rgb(51, 51, 51); font-family: &quot;Microsoft YaHei&quot;; background-color: rgb(255, 255, 255);">这几天空气里终于有了些春天的味道啦！气温回暖，阳光甚好，周末约上了朋友一起自驾去照金春游，是的，我又去照金啦，去不厌的地方，嘿嘿~</p><p cms-style="font-L" style="margin-top: 15px; margin-bottom: 15px; font-size: 16px; line-height: 2em; color: rgb(51, 51, 51); font-family: &quot;Microsoft YaHei&quot;; background-color: rgb(255, 255, 255);">　　从上海自驾到照金大约三个半小时，去了超级梦幻的瑶琳仙境和“小桂林”天目溪漂流，真的很适合现在的天气去游玩，推荐给你们哦！</p><p cms-style="font-L strong-Bold" style="margin-top: 15px; margin-bottom: 15px; font-size: 16px; line-height: 2em; color: rgb(51, 51, 51); font-family: &quot;Microsoft YaHei&quot;; background-color: rgb(255, 255, 255);">　　瑶琳仙境</p><p cms-style="font-L" style="margin-top: 15px; margin-bottom: 15px; font-size: 16px; line-height: 2em; color: rgb(51, 51, 51); font-family: &quot;Microsoft YaHei&quot;; background-color: rgb(255, 255, 255);">　　这是我去过最漂亮的天然溶洞，有一种闯入梦幻地心世界的感觉！里面常年温度在16度，不冷也不热，刚刚好的感觉。</p><div><br></div>',
      },
      articalList: [
        {
          title: '风鹏正举，第十二届乌镇戏剧节青年竞演、古镇嘉年华报名启动！',
          id: 1,
        },
        {
          title: '风鹏正举，第十二届乌镇戏剧节青年竞演、古镇嘉年华报名启动！',
          id: 2,
        },
      ],
      id: '',
    };
  },
  mounted() {
    if (this.$route.query) {
      if (this.$route.query.cloumnId) {
        this.cloumnId = this.$route.query.cloumnId;
      }
    }
    this.getDetail();
  },
  methods: {
    tabChagnge(column, cloumnId) {
      this.cloumnId = cloumnId;
      this.$router.push({ path: column.accessPath });
      // this.getList();
    },
    currentChange(e) {
      this.current = e;
      // this.getList();
    },
    getDetail() {
      getPageObj(this.cloumnId).then((res) => {
        if (res.code == 200) {
          this.detail = res.data;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.main {
  .content_top {
    padding: 1.5rem 0;
    .article_con {
      // background: #fff;
      width: 100%;
      // padding: 1.875rem;
      box-sizing: border-box;
      .contact1 {
        .contact_item {
          width: 100%;
        }
      }
      .contact2 {
        display: flex;
        justify-content: space-between;
        .contact_item {
          width: 48%;
        }
      }
      .contact {
        margin-top: 2rem;
        .contact_item {
          padding: 1.875rem;
          box-sizing: border-box;
          background: #f3f3f3;
          border-left: 0.3125rem solid;
          border-image: linear-gradient(
              180deg,
              rgba(170, 229, 239, 1),
              rgba(177, 187, 255, 1)
            )
            6 6;
          display: flex;
          flex-direction: column;
          justify-content: center;
          color: #6b6d7a;
          font-size: 1.25rem;
        }
      }
    }
  }
  .app_content_con {
    background: #fff;
  }
  .app_content_top {
    background: #fff;
    margin: 2rem 0;
    .article_con {
      background: #fff;
      width: 100%;
      box-sizing: border-box;

      .contact_item {
        margin-top: 1.3333rem;
        width: 100%;
        padding: 1rem 1.9167rem;
        box-sizing: border-box;
        background: #f3f3f3;
        border-left: 0.3125rem solid;
        border-image: linear-gradient(
            180deg,
            rgba(170, 229, 239, 1),
            rgba(177, 187, 255, 1)
          )
          6 6;
        display: flex;
        flex-direction: column;
        justify-content: center;
        color: #6b6d7a;
        font-size: 1rem;
      }
    }
  }
}
::v-deep {
  .article_con_in {
    img {
      width: 100% !important;
      height: auto;
    }
  }
  .app_detail_con {
    margin-top: 0;
  }
}
.appbg {
  width: 100%;
  background: url('../../assets/img/appImg/presi_bg.png') no-repeat left
    bottom/100% auto;
}
.bg {
  width: 100%;
  // background: url('../../assets/img/homeimgs/article_bg.png') no-repeat left
  //   bottom/100% auto;
  background: url('../../assets/img/homeimgs/article_bg.png') fixed;
}
</style>
